module.exports = __webpack_public_path__ + "../public/img/ylw_icoLoja.f9b24744.png";